import React, {useEffect, useRef, useState} from 'react';
import jwt from 'jwt-decode';

import {useNavigate} from "react-router";
import {Link, useSearchParams} from "react-router-dom";

import {mainRolesRoutes, rolesCodes} from "../../global";

import {Alert, Checkbox, Collapse, Divider, IconButton, InputAdornment, TextField, useMediaQuery} from '@mui/material';
import Header from '../Header';
import './style.css';
import {useTranslation, withTranslation} from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import {Visibility} from "@mui/icons-material";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {validateEmail, validatePassword} from "../../services/CheckUtils";
import dataProvider from "../../provider/api-interface";

import Background from "../../media/images/LoginBackground.jpg";
import FooterCabana from "../pages/FooterCabana";

import './LoginSignup.css';
import * as EmailValidator from "email-validator";

import {FacebookLoginClient} from '@greatsumini/react-facebook-login';

import ReCAPTCHA from "react-google-recaptcha";
import {useCabanaContext} from "../CabanaContext";
import {useAnalytics} from "../../hook/useAnalytics";

function LoginSignup() {
    const {saveJwtToken} = useCabanaContext();
    const isDesktop = useMediaQuery('(min-width:992px)'); // lg breakpoint

    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [recaptchaRef, setRecaptchaRef] = useState<any>(null);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const [isEmailValid, setIsEmailValid] = useState(true);
    const [alertOpen, setAlertOpen] = useState<boolean>(false);
    const [alertType, setAlertType] = useState<"error" | "success">("error");
    const [alertText, setAlertText] = useState<any>(t('wrongCredentials'));

    //SIGNUP
    const [signupPassword, setSignupPassword] = useState<string>("");
    const [isSignupPasswordValid, setIsSignupPasswordValid] = useState<boolean>(false);
    const [termsAccepted, setTermsAccepted] = useState<boolean>(false);
    const [showSignupPassword, setShowSignupPassword] = useState(false);
    const [termsStyle, setTermsStyle] = useState<any>({fontWeight: "400"});
    const [marketingAccepted, setMarketingAccepted] = useState<boolean>(false);
    const [marketingStyle, setMarketingStyle] = useState<any>({fontWeight: "400"});
    const handleClickShowSignupPassword = () => setShowSignupPassword(!showSignupPassword);
    const [signupEmail, setSignupEmail] = useState<string>("");
    const [isSignupEmailValid, setIsSignupEmailValid] = useState(true);
    const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
    const facebookAppId: any = process.env.REACT_APP_FACEBOOK_APP_ID;
    const { trackEvent } = useAnalytics();
    FacebookLoginClient.init({ appId: facebookAppId, version: 'v16.0' });

    useEffect(() => {
        let tempReCaptchaRef: any = React.createRef();
        setRecaptchaRef(tempReCaptchaRef);
    }, []);

    const autoClose = () => {
        setTimeout(() => {
            setAlertOpen(false);
        }, 3000);
    };

    if(searchParams.get('confirmToken') !== null) {
        const token: any = searchParams.get('confirmToken');
        dataProvider.confirmUnifiedRegistration(token).then((response: any) => {
            if(response !== null) {
                setAlertOpen(true);
                setAlertType("success");
                setAlertText(t("registrationSuccess"));
                autoClose();
            }
        });
    }

    const setLanguage = (language: string) => {
        i18n.changeLanguage(language).then(() => {});
    }

    const handleSignupEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSignupEmail(event.target.value);
        setIsSignupEmailValid(validateSignupEmail(event.target.value));
    };

    const validateSignupEmail = (email: string) => {
        return EmailValidator.validate(email);
    };

    const handleSignupPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSignupPassword(event.target.value);
        setIsSignupPasswordValid(validatePassword(event.target.value));
    };

    const handleTermsAccepted = (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.checked){
            setTermsStyle({fontWeight: "700"});
            setTermsAccepted(true);
        } else {
            setTermsStyle({fontWeight: "400"});
            setTermsAccepted(false);
        }
    }

    const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
        setIsEmailValid(validateEmail(event.target.value));
    };

    const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
    };

    const handleLoginFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        let response: any = await dataProvider.login(email, password);
        console.log(response)

        if(!response) {
            setAlertOpen(true);
            setAlertType("error");
            setAlertText(t("wrongCredentialsParagraph"));
            return;
        }

        if(response.hasOwnProperty('userStatus') && parseInt(response.userStatus) === 0) { //if user registration is not complete
            const userId: string = response.userId;
            const encodedUserId = btoa(userId);
            trackEvent("registry_login", {
                category: "cabana_event",
                label: "User Login",
                user_id: userId,
                registry_id: userId,
            });
            navigate(`/get-started/${encodedUserId}`);
        } else {
            //console.log(response);
            const token: string = response.token;
            //console.log(token); return;
            saveJwtToken(token)
            let user: any = jwt(token);
            trackEvent("registry_login", {
                category: "cabana_event",
                label: "User Login",
                user_id: user.id,
                registry_id: user.id
            });
            const redirectURL = searchParams.get('redirectURL');
            if( redirectURL ) {
                window.location.href = redirectURL;
            }
            else {
                let roleCode: number = parseInt(user.role);
                let role = rolesCodes[roleCode];
                if (roleCode === 1) {
                    const language = 'en_gb';
                    setLanguage(language);
                    dataProvider.getWishlistByGifteeId(user.id, token).then((wishlist: any) => {
                        if (wishlist !== null && wishlist.data !== null) {
                            //console.log(wishlist, 'wishlist')
                            //console.log(`/${mainRolesRoutes[role]}/registry/${wishlist[0].id}`)
                            navigate(`/${mainRolesRoutes[role]}/registry/${wishlist.data[0].list_code}`);
                        } else {
                            //console.log('redirect to login success ok')
                            //return;
                            navigate(`/${mainRolesRoutes[role]}/login-success`);
                        }
                    });

                }

                if (roleCode === 2) {
                    let wishlistId = searchParams.get('id');
                    if (wishlistId !== null) {
                        navigate(`/${mainRolesRoutes[role]}/registry/${wishlistId}`);
                    } else {
                        navigate(`/${mainRolesRoutes[role]}/login-success`);
                    }
                }

            }
        }
    };

     // Create a reference for the form
    // Function to handle submitting when clicking the external button
    const signupFormRef = useRef<HTMLFormElement>(null);
    const handleSignupExternalSubmit = () => {
        if (signupFormRef.current) {
            signupFormRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
    };

    const handleSignupFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setButtonDisabled(true);
        recaptchaRef.current.execute();
        let recaptchaToken = recaptchaRef.current.getValue();
        //console.log(recaptchaToken, 'recaptchaToken'); return;
        //LOGIN INFO
        if (signupEmail === '' || signupPassword === '') {
            setAlertOpen(true);
            setAlertType("error");
            setAlertText(t("emptyFieldsParagraph"));
            autoClose();
            setButtonDisabled(false);
            return;
        }

        if (!isSignupPasswordValid) {
            setAlertOpen(true);
            setAlertType("error");
            setAlertText(t("invalidPasswordParagraph"));
            setButtonDisabled(false);
            autoClose();
            return;
        }

        //VALIDATE MAIL AND PHONE
        if(!validateSignupEmail(signupEmail)) {
            setAlertText(t('mailNotValid'));
            setAlertOpen(true);
            setButtonDisabled(false);
            autoClose();
            return;
        }

        if (!termsAccepted) {
            setAlertOpen(true);
            setAlertType("error");
            setAlertText(t("termsNotAcceptedParagraph"));
            setButtonDisabled(false);
            autoClose();
            return;
        }

        let registrationObject = {
            email: signupEmail,
            password: signupPassword,
            acceptance_privacy_and_terms: 1,
            acceptance_condition_settings: 1,
            accept_marketing_consents: marketingAccepted ? 1 : 0,
            recaptcha_token: recaptchaToken
        }

        await dataProvider.unifiedRegistrationStep1(registrationObject).then((response: any) => {
            if(response !== null) {
                if(response.status === 200) {
                    const userId: string = response.data.userId;
                    const encodedUserId = btoa(userId);
                    trackEvent("registry_registration", {
                        category: "cabana_event",
                        label: "User Registration",
                        user_id: userId
                    });
                    navigate(`/get-started/${encodedUserId}`);
                } else {
                    setAlertText(t('registrationError'));
                    if(response.status === 409) {
                        setAlertText(t('emailAlreadyExists'));
                    }
                    setAlertOpen(true);
                    setAlertType("error");
                    setButtonDisabled(false);
                    autoClose();
                }
            }
        });

    };

    const handleMarketingAccepted = (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.checked){
            setMarketingStyle({fontWeight: "700"});
            setMarketingAccepted(true)
        } else {
            setMarketingStyle({fontWeight: "400"});
            setMarketingAccepted(false)
        }
    }

    return (
        <div>
            <Header hideLanguageSelect={true}
                    /*link={link}
                    textLink={t('backTo')}*/
                    languageLocale={'en'}
                    hideLogout={true}
            />
            <div className="row no-gutter LoginSignupContainer">
                <div className="col-12 col-lg-6 PublicRegistrationTitle" style={{
                    minHeight: '21vh',
                    height: 'calc(100vh - 60px)',
                    background: `url(${Background})`,
                    backgroundSize: 'cover',
                    backgroundPosition: '50% 48%',
                    backgroundRepeat: 'no-repeat'
                }}>
                </div>
                <div
                    className="col-12 col-lg-6 d-flex FormsContainer flex-column align-items-center justify-content-start px-0 px-lg-3">
                    <Collapse className="FgiftCustomCollapse" in={alertOpen}>
                        <Alert severity={alertType}
                               onClose={() => setAlertOpen(false)}
                               action={
                                   <IconButton
                                       aria-label="close"
                                       color="inherit"
                                       size="small"
                                       onClick={() => {
                                           setAlertOpen(false);
                                       }}
                                   >
                                       <CloseIcon fontSize="inherit"/>
                                   </IconButton>
                               }
                        >
                            {alertText}
                        </Alert>
                    </Collapse>
                    <div className="LoginRow row w-100 mt-3 mb-2 justify-content-lg-between">
                        <div
                            className="col-12 py-4 col-lg-3 d-none d-lg-flex flex-column justify-content-lg-start align-items-lg-start LoginSignupAccordionSummary">
                            <h3>{t('loginSignupPage.login')}</h3>
                            <p>{t('loginSignupPage.loginSubtitle')}</p>
                        </div>
                        <div className="col-12 col-lg-8 d-none d-lg-block">
                            {isDesktop ? <form className="LoginForm p-0 mt-5" onSubmit={handleLoginFormSubmit}>
                                    <div className="FormContainer">
                                        <TextField
                                            label={t("emailLabel")}
                                            value={email}
                                            onChange={handleEmailChange}
                                            error={!isEmailValid}
                                            helperText={!isEmailValid && t("notValidMailHelper")}
                                            variant="outlined"
                                        />
                                        <TextField
                                            type={showPassword ? "text" : "password"}
                                            label={t("password")}
                                            value={password}
                                            onChange={handlePasswordChange}
                                            variant="outlined"
                                            InputProps={{ // <-- This is where the toggle button is added.
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowPassword}
                                                        >
                                                            {showPassword ? <Visibility/> : <VisibilityOffIcon/>}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                        <Link to={`/reset-password`} className="ResetPasswordLink">
                                            {t("loginSignupPage.forgotPassword")}
                                        </Link>
                                    </div>
                                    <div className="ButtonContainer" style={{position: 'relative'}}>
                                        <button type="submit" className="Fgift-button Fgift-button-reverted">
                                            {t("loginButton")}
                                        </button>
                                    </div>
                                </form>
                                : ''}
                        </div>
                        <div className="col-12 d-block d-lg-none no-gutters">
                            <h4 className="mb-4 mt-2">LOGIN</h4>
                            {!isDesktop ? <form className="LoginForm p-0" onSubmit={handleLoginFormSubmit}>
                                    <div className="FormContainer">
                                        <TextField
                                            label={t("emailLabel")}
                                            value={email}
                                            onChange={handleEmailChange}
                                            error={!isEmailValid}
                                            helperText={!isEmailValid && t("notValidMailHelper")}
                                            variant="outlined"
                                        />
                                        <TextField
                                            type={showPassword ? "text" : "password"}
                                            label={t("password")}
                                            value={password}
                                            onChange={handlePasswordChange}
                                            variant="outlined"
                                            InputProps={{ // <-- This is where the toggle button is added.
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowPassword}
                                                        >
                                                            {showPassword ? <Visibility/> : <VisibilityOffIcon/>}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                        <Link to={`/reset-password`} className="ResetPasswordLink">
                                            {t("forgotPassword")}
                                        </Link>
                                    </div>
                                    <div className="ButtonContainer" style={{position: 'relative'}}>
                                        <button type="submit" className="Fgift-button Fgift-button-reverted">
                                            {t("loginButton")}
                                        </button>
                                    </div>
                                </form>
                                : ''}
                        </div>
                        <div className="col-12 col-lg-2 d-none d-lg-block"></div>
                    </div>
                    <Divider sx={{borderColor: "#cccccc",width: "105%"}} component="div" />
                    <div className="SignupRow row w-100 mt-3 mb-5 justify-content-lg-between">
                        <div
                            className="col-12 col-lg-3 py-4 d-none d-lg-flex flex-column justify-content-lg-start align-items-lg-start LoginSignupAccordionSummary">
                            <h3>{t('loginSignupPage.signup')}</h3>
                            <p>{t('loginSignupPage.signupSubtitle')}</p>
                        </div>
                        <div className="col-12 col-lg-8 d-none d-lg-block">
                            {isDesktop ? <form ref={signupFormRef} className="LoginForm p-0 mt-5 mb-4" onSubmit={handleSignupFormSubmit}>
                                <div className="FormContainer">
                                    <TextField
                                        label={t("emailLabel")}
                                        value={signupEmail}
                                        onChange={handleSignupEmailChange}
                                        required={true}
                                        error={!isSignupEmailValid}
                                        helperText={!isSignupEmailValid && t("notValidMailHelper")}
                                        variant="outlined"
                                    />
                                    <TextField
                                        type={showSignupPassword ? "text" : "password"}
                                        label={t('passwordLabel')}
                                        value={signupPassword}
                                        onChange={handleSignupPasswordChange}
                                        helperText={t("loginSignupPage.passwordHelper")}
                                        variant="outlined"
                                        InputProps={{ // <-- This is where the toggle button is added.
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowSignupPassword}
                                                    >
                                                        {showSignupPassword ? <Visibility/> :
                                                            <VisibilityOffIcon/>}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    size="invisible"
                                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY as string}
                                    onChange={(token: any) => {
                                        console.log(token);
                                    }}
                                />
                            </form> : ''}
                            {isDesktop ?
                                <div>
                                    <div className="mt-2 AcceptTermsContainer">
                                        <Checkbox
                                            onChange={handleTermsAccepted}
                                            color="primary"
                                            inputProps={{'aria-label': 'secondary checkbox'}}
                                            sx={{
                                                color: 'black',
                                                '&.Mui-checked': {
                                                    color: 'black',
                                                },
                                            }}
                                        /> <span
                                        style={termsStyle}>{t('acceptTermsAndConditionsText')}
                                        <a
                                            style={termsStyle}
                                            href="https://cabanamagazine.com/pages/terms-and-conditions"
                                            target="_blank">{t('termsAndConditions')}</a> & <a
                                            style={termsStyle}
                                            href="https://cabanamagazine.com/pages/privacy-policy"
                                            target="_blank">{t('privacyPolicy')}</a></span>
                                    </div>
                                    <div className="mb-5 AcceptMarketingContainer">
                                        <Checkbox
                                            onChange={handleMarketingAccepted}
                                            color="primary"
                                            inputProps={{'aria-label': 'secondary checkbox'}}
                                            sx={{
                                                color: 'black',
                                                '&.Mui-checked': {
                                                    color: 'black',
                                                },
                                            }}
                                        /> <span
                                        style={marketingStyle}>{t('loginSignupPage.marketingText')}</span>
                                    </div>
                                    <div className="ButtonContainer" style={{position: 'relative'}}>
                                        <button disabled={buttonDisabled} id="signup-confirm-button"
                                                className="Fgift-button" onClick={() => {
                                            handleSignupExternalSubmit()
                                        }}>
                                            {t('loginSignupPage.CTA')}
                                        </button>
                                    </div>
                                </div>
                        : ''}
                    </div>
                    <div className="col-12 d-block d-lg-none no-gutters">
                        <h4 className="mb-4">SIGN UP</h4>
                        {!isDesktop ? <form className="LoginForm p-0" onSubmit={handleSignupFormSubmit}>
                            <div className="FormContainer">
                                    <TextField
                                        label={t("emailLabel")}
                                        value={signupEmail}
                                        onChange={handleSignupEmailChange}
                                        required={true}
                                        error={!isSignupEmailValid}
                                        helperText={!isSignupEmailValid && t("notValidMailHelper")}
                                        variant="outlined"
                                    />
                                    <TextField
                                        type={showSignupPassword ? "text" : "password"}
                                        label={t('passwordLabel')}
                                        value={signupPassword}
                                        onChange={handleSignupPasswordChange}
                                        helperText={t("loginSignupPage.passwordHelper")}
                                        variant="outlined"
                                        InputProps={{ // <-- This is where the toggle button is added.
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowSignupPassword}
                                                    >
                                                        {showSignupPassword ? <Visibility/> :
                                                            <VisibilityOffIcon/>}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                    <div className="AcceptTermsContainer">
                                        <Checkbox
                                            onChange={handleTermsAccepted}
                                            color="primary"
                                            inputProps={{'aria-label': 'secondary checkbox'}}
                                            sx={{
                                                color: 'black',
                                                '&.Mui-checked': {
                                                    color: 'black',
                                                },
                                            }}
                                        /> <span
                                        style={termsStyle}>{t('acceptTermsAndConditionsText')}
                                        <a
                                            style={termsStyle}
                                            href="https://cabanamagazine.com/pages/terms-and-conditions"
                                            target="_blank">{t('termsAndConditions')}</a> & <a
                                            style={termsStyle}
                                            href="https://cabanamagazine.com/pages/privacy-policy"
                                            target="_blank">{t('privacyPolicy')}</a></span>
                                    </div>
                                    <div className="AcceptMarketingContainer">
                                        <Checkbox
                                            onChange={handleMarketingAccepted}
                                            color="primary"
                                            inputProps={{'aria-label': 'secondary checkbox'}}
                                            sx={{
                                                color: 'black',
                                                '&.Mui-checked': {
                                                    color: 'black',
                                                },
                                            }}
                                        /> <span
                                        style={marketingStyle}>{t('loginSignupPage.marketingText')}</span>
                                    </div>
                                </div>
                                <div className="ButtonContainer" style={{position: 'relative'}}>
                                    <button disabled={buttonDisabled} id="signup-confirm-button" type="submit"
                                            className="Fgift-button">
                                        {t('loginSignupPage.CTA')}
                                    </button>
                                </div>
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    size="invisible"
                                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY as string}
                                    onChange={(token: any) => {
                                        console.log(token);
                                    }}
                                />
                            </form> : ''}
                        </div>
                        <div className="col-12 col-lg-2 d-none d-lg-block"></div>
                    </div>
                </div>
            </div>
            {!isDesktop ? <FooterCabana showDisclaimer={false}/> : ''}
        </div>
    );
}

export default withTranslation()(LoginSignup);
